module.exports = __webpack_public_path__ + "static/media/icon_stickers_big.ec9b986e.png";